import React from "react";
import styled from "@emotion/styled";
import { Text } from 'src/components';
import { colors } from "src/theme";

const TagStyle = styled.div((props: { background: string }) => ({
  padding: '2px',
  borderRadius: '4px',
  backgroundColor: props.background,
}));

interface TagProps {
  background?: string;
  value?: React.ReactNode;
}

export const Tag: React.FC<TagProps> = ({ value, background = colors.background1 }) => {
  const isString = (v: any): v is string => typeof v === 'string';

  return (
    <TagStyle background={background}>
      {isString(value) ? (
        <Text type='tiny'>{value}</Text>
      ) : (
        value
      )}
    </TagStyle>
  )
};

